import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { CertifiableSystem } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { PageComponent } from '@workspace-app/shared';
import { ApprovedSystemViewComponent } from './approved-system-view.component';
import { ApprovedSystemsDataService } from '../approved-systems/approved-systems-data.service';

@Component({
  selector: 'app-approved-system-standalone-view',
  standalone: true,
  imports: [PageComponent, ApprovedSystemViewComponent, AsyncPipe],
  providers: [DialogService, MessageService],
  template: `
    @if (system$ | async; as system) {
      <app-page [title]="'System ' + (system.completeApprovalNumber || '')" [showBackButton]="true">
        <app-approved-system-view [systemInput]="system" />
      </app-page>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        width: 100%;
      }
    `,
  ],
})
export class ApprovedSystemStandaloneViewComponent {
  private route = inject(ActivatedRoute);
  private dataService = inject(ApprovedSystemsDataService);

  system$: Observable<CertifiableSystem>;

  constructor() {
    this.system$ = this.dataService.fetchSystem(this.route.snapshot.params['id']);
  }
}
